/* eslint-disable */
const storageConstant = {
    USER: 'user',
	GUEST_USER: 'guestUser',
    USER_LIST: 'userList',
    ACCESS_TOKEN: 'token',
    REFRESH_TOKEN: 'rtoken',
    FORM_DATA: 'form_data',
}
export default storageConstant